module.exports = __webpack_public_path__ + "img/left1.b4a242b3.png";